//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "OfficeSignWrite",
  components: {},
  data: function data() {
    return {
      points: [],
      canvasTxt: null,
      startX: 0,
      startY: 0,
      moveY: 0,
      moveX: 0,
      endY: 0,
      endX: 0,
      w: null,
      h: null,
      isDown: false
    };
  },
  computed: {},
  mounted: function mounted() {
    var canvas = this.$refs.canvasF;
    this.canvasTxt = canvas.getContext("2d");
  },
  methods: {
    getWriteImg: function getWriteImg() {
      return this.$refs.canvasF.toDataURL();
    },
    //电脑设备事件
    mouseDown: function mouseDown(ev) {
      ev = ev || event;
      ev.preventDefault();
      var obj = {
        x: ev.offsetX,
        y: ev.offsetY
      };
      this.startX = obj.x;
      this.startY = obj.y;
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
      this.isDown = true;
    },
    //移动设备事件
    touchStart: function touchStart(ev) {
      ev = ev || event;
      ev.preventDefault();

      if (ev.touches.length == 1) {
        var obj = {
          x: ev.targetTouches[0].clientX - 415,
          y: ev.targetTouches[0].clientY - 250
        };
        this.startX = obj.x;
        this.startY = obj.y;
        this.canvasTxt.beginPath();
        this.canvasTxt.moveTo(this.startX, this.startY);
        this.canvasTxt.lineTo(obj.x, obj.y);
        this.canvasTxt.stroke();
        this.canvasTxt.closePath();
        this.points.push(obj);
      }
    },
    //电脑设备事件
    mouseMove: function mouseMove(ev) {
      ev = ev || event;
      ev.preventDefault();

      if (this.isDown) {
        var obj = {
          x: ev.offsetX,
          y: ev.offsetY
        };
        this.moveY = obj.y;
        this.moveX = obj.x;
        this.canvasTxt.beginPath();
        this.canvasTxt.moveTo(this.startX, this.startY);
        this.canvasTxt.lineTo(obj.x, obj.y);
        this.canvasTxt.stroke();
        this.canvasTxt.closePath();
        this.startY = obj.y;
        this.startX = obj.x;
        this.points.push(obj);
      }
    },
    //移动设备事件
    touchMove: function touchMove(ev) {
      ev = ev || event;
      ev.preventDefault();

      if (ev.touches.length == 1) {
        var obj = {
          x: ev.targetTouches[0].clientX - 415,
          y: ev.targetTouches[0].clientY - 250
        };
        this.moveY = obj.y;
        this.moveX = obj.x;
        this.canvasTxt.beginPath();
        this.canvasTxt.moveTo(this.startX, this.startY);
        this.canvasTxt.lineTo(obj.x, obj.y);
        this.canvasTxt.stroke();
        this.canvasTxt.closePath();
        this.startY = obj.y;
        this.startX = obj.x;
        this.points.push(obj);
      }
    },
    //电脑设备事件
    mouseUp: function mouseUp(ev) {
      ev = ev || event;
      ev.preventDefault();
      var obj = {
        x: ev.offsetX,
        y: ev.offsetY
      };
      this.canvasTxt.beginPath();
      this.canvasTxt.moveTo(this.startX, this.startY);
      this.canvasTxt.lineTo(obj.x, obj.y);
      this.canvasTxt.stroke();
      this.canvasTxt.closePath();
      this.points.push(obj);
      this.points.push({
        x: -1,
        y: -1
      });
      this.isDown = false;
    },
    //移动设备事件
    touchEnd: function touchEnd(ev) {
      ev = ev || event;
      ev.preventDefault();

      if (ev.touches.length == 1) {
        var obj = {
          x: ev.targetTouches[0].clientX - 415,
          y: ev.targetTouches[0].clientY - 250
        };
        this.canvasTxt.beginPath();
        this.canvasTxt.moveTo(this.startX, this.startY);
        this.canvasTxt.lineTo(obj.x, obj.y);
        this.canvasTxt.stroke();
        this.canvasTxt.closePath();
        this.points.push(obj);
        this.points.push({
          x: -1,
          y: -1
        });
      }
    },
    //重写
    overwrite: function overwrite() {
      this.canvasTxt.clearRect(0, 0, this.$refs.canvasF.width, this.$refs.canvasF.height);
      this.points = [];
    }
  }
};